import axios from "axios";

import { MlFeature, MlTarget, NormalizeFeaturePackage } from "../components/ml/types";

export interface StoredFeatureTemplate {
  name: string;
  features: MlFeature[];
  createdAt: string;
  isDefault?: boolean;
  /** Normalization settings for each feature (e.g. "per 100 m"). Stored as-is in the schemaless JSON backend. */
  normalizationFeatures?: NormalizeFeaturePackage[];
  /** The ML target feature selected when this template was saved. */
  targetFeature?: MlTarget;
}

const BASE_URL = `${process.env.REACT_APP_USER_SERVICE}/user/setting/FeatureTemplate`;

export const featureTemplateApi = {
  // Get all templates - returns JSON in localStorage format
  async getAll(): Promise<StoredFeatureTemplate[]> {
    const response = await axios.get<StoredFeatureTemplate[]>(BASE_URL);
    return Array.isArray(response.data) ? response.data : [];
  },

  // Import templates - stores JSON exactly as provided, returns same JSON
  async import(templates: StoredFeatureTemplate[]): Promise<StoredFeatureTemplate[]> {
    const response = await axios.post<StoredFeatureTemplate[]>(
      `${BASE_URL}/import`,
      templates
    );
    return response.data;
  }
};
